import {createSelector} from 'reselect';
import {AppState} from './../../../store';
import {hotelAreaReviewInput, cityCodeReviewInput} from '@ibibo/hotels-review-reducer';

export const commonSelector = (state: AppState) => state.common;

export const hotelsPartnerFn = createSelector(commonSelector, item => item.partner);

export const metaPartnerSelectorFn = createSelector(commonSelector, item => item.metaPartner);

export const commonSelectorFn = createSelector(commonSelector, item => item);

export const countrySelectorFn = createSelector(commonSelectorFn, item => item.country);

export const roomStringSelectorFn = createSelector(commonSelectorFn, item => item.roomString);

export const checkoutSelectorFn = createSelector(commonSelectorFn, item => item.checkout);

export const checkinSelectorFn = createSelector(commonSelectorFn, item => item.checkin);

export const destinationSelectorFn = createSelector(commonSelectorFn, item => item.destination);

export const cityIdSelectorFn = createSelector(destinationSelectorFn, item => item._id);

export const numberOfNightsSelector = createSelector(commonSelectorFn, ({checkin, checkout}) => {
  const numberOfNights = Math.floor(
    (checkout.date.getTime() - checkin.date.getTime()) / (1000 * 3600 * 24),
  );
  return numberOfNights;
})

// this will be hotel id on details and review
export const hotelIdSelectorFnFromCommon = createSelector(destinationSelectorFn, item => item._id);

// should extract out segment slider into separate reducer altogether
export const segmentSliderSelectorFn = createSelector(
  commonSelectorFn,
  item => item.segmentSliderApi,
);

export const reviewPageSrpUrlParamsSelectorFn = createSelector(
  checkinSelectorFn,
  checkoutSelectorFn,
  roomStringSelectorFn,
  destinationSelectorFn,
  hotelAreaReviewInput,
  cityCodeReviewInput,
  (checkin, checkout, roomString, destination, hotelArea, cityCode) => ({
    checkin,
    checkout,
    roomString,
    destination: {...destination, _id: cityCode || destination._id, n: hotelArea || destination.n},
  }),
);
